import React from 'react';
import styles from './Toggle.module.scss';

const Toggle = ({ enabled, onChange, ariaLabel }) => {
  return (
    <button
      type='button'
      className={[
        styles.toggle,
        enabled ? styles['toggle--on'] : styles['toggle--off'],
      ].join(' ')}
      onClick={onChange}
      aria-pressed={enabled}
      aria-label={ariaLabel}
    >
      <span className={styles.toggle__thumb}>
        <svg
          className={[
            styles.toggle__icon,
            styles['toggle__icon--cross'],
          ].join(' ')}
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        >
          <line x1='18' y1='6' x2='6' y2='18' />
          <line x1='6' y1='6' x2='18' y2='18' />
        </svg>
        <svg
          className={[
            styles.toggle__icon,
            styles['toggle__icon--check'],
          ].join(' ')}
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        >
          <polyline points='20 6 9 17 4 12' />
        </svg>
      </span>
    </button>
  );
};

export default Toggle;